import React from 'react'
import { Link } from 'gatsby'

export const SignUpInfoCard = () => (
    <div
        className="info-card bg-white mb-3 p-3"
        style={{ borderRadius: '16px', border: '1px solid #e3f2f2' }}
    >
        <p
            style={{
                textAlign: 'center',
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.6',
                margin: 0,
            }}
        >
            You're signed up for our newsletter!
            <br />
            <span>
                If you have any questions in the meantime,{' '}
                <Link className="milan-text-primary" to="/locations/contact/">
                    please contact us
                </Link>
                .
            </span>
        </p>
    </div>
)
